// class HTMLUpdateUtility {
//   /**
//    * Used to swap an HTML node with a new node.
//    * The new node is inserted as a previous sibling to the old node, the old node is hidden, and then the old node is removed.
//    *
//    * The function currently uses a double buffer approach, but this should be replaced by a view transition once it is more widely supported https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
//    */
//   static viewTransition(oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) {
//     preProcessCallbacks?.forEach((callback) => callback(newContent));

//     const newNodeWrapper = document.createElement('div');
//     HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
//     const newNode = newNodeWrapper.firstChild;

//     // dedupe IDs
//     const uniqueKey = Date.now();
//     oldNode.querySelectorAll('[id], [form]').forEach((element) => {
//       element.id && (element.id = `${element.id}-${uniqueKey}`);
//       element.form && element.setAttribute('form', `${element.form.getAttribute('id')}-${uniqueKey}`);
//     });

//     oldNode.parentNode.insertBefore(newNode, oldNode);
//     oldNode.style.display = 'none';

//     postProcessCallbacks?.forEach((callback) => callback(newNode));

//     setTimeout(() => oldNode.remove(), 500);
//   }

//   // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
//   static setInnerHTML(element, html) {
//     element.innerHTML = html;
//     element.querySelectorAll('script').forEach((oldScriptTag) => {
//       const newScriptTag = document.createElement('script');
//       Array.from(oldScriptTag.attributes).forEach((attribute) => {
//         newScriptTag.setAttribute(attribute.name, attribute.value);
//       });
//       newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
//       oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
//     });
//   }
// }

// class QuantityInputDawn extends HTMLElement {
//   constructor() {
//     super();
//     this.input = this.querySelector('input');
//     this.changeEvent = new Event('change', { bubbles: true });
//     this.input.addEventListener('change', this.onInputChange.bind(this));
//     this.querySelectorAll('button').forEach((button) =>
//       button.addEventListener('click', this.onButtonClick.bind(this))
//     );
//   }

//   quantityUpdateUnsubscriber = undefined;

//   connectedCallback() {
//     this.validateQtyRules();
//     this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
//   }

//   disconnectedCallback() {
//     if (this.quantityUpdateUnsubscriber) {
//       this.quantityUpdateUnsubscriber();
//     }
//   }

//   onInputChange(event) {
//     this.validateQtyRules();
//   }

//   onButtonClick(event) {
//     event.preventDefault();
//     const previousValue = this.input.value;

//     if (event.target.name === 'plus') {
//       if (parseInt(this.input.dataset.min) > parseInt(this.input.step) && this.input.value == 0) {
//         this.input.value = this.input.dataset.min;
//       } else {
//         this.input.stepUp();
//       }
//     } else {
//       this.input.stepDown();
//     }

//     if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

//     if (this.input.dataset.min === previousValue && event.target.name === 'minus') {
//       this.input.value = parseInt(this.input.min);
//     }
//   }

//   validateQtyRules() {
//     const value = parseInt(this.input.value);
//     if (this.input.min) {
//       const buttonMinus = this.querySelector(".quantity__button[name='minus']");
//       buttonMinus.classList.toggle('disabled', parseInt(value) <= parseInt(this.input.min));
//     }
//     if (this.input.max) {
//       const max = parseInt(this.input.max);
//       const buttonPlus = this.querySelector(".quantity__button[name='plus']");
//       buttonPlus.classList.toggle('disabled', value >= max);
//     }
//   }
// }

// customElements.define('quantity-input-dawn', QuantityInputDawn);

// class ProductVariantSelects extends HTMLElement {
//   constructor() {
//     super();
//   }

//   connectedCallback() {
//     this.addEventListener('change', (event) => {
//       const target = this.getInputForEventTarget(event.target);
//       this.updateSelectionMetadata(event);

//       publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
//         data: {
//           event,
//           target,
//           selectedOptionValues: this.selectedOptionValues,
//         },
//       });
//     });
//   }

//   updateSelectionMetadata({ target }) {
//     const { value, tagName } = target;

//     if (tagName === 'SELECT' && target.selectedOptions.length) {

//       Array.from(target.options)
//         .find((option) => option.getAttribute('selected'))
//         .removeAttribute('selected');

//       // change previous target.selectedOptions with new value
//       const newSelectedOption = Array.from(target.options).find((option) => option.value === value);
//       if (newSelectedOption) {
//         newSelectedOption.setAttribute('selected', 'selected');
//       }

//       const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
//       const selectedDropdownSwatchValue = target
//         .closest('.product-form__input')
//         .querySelector('[data-selected-value] > .product-option__swatch');
//       if (!selectedDropdownSwatchValue) return;
//       if (swatchValue) {
//         selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
//         selectedDropdownSwatchValue.classList.remove('product-option__swatch--unavailable');
//       } else {
//         selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
//         selectedDropdownSwatchValue.classList.add('product-option__swatch--unavailable');
//       }

//       selectedDropdownSwatchValue.style.setProperty(
//         '--swatch-focal-point',
//         target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
//       );
//     } else if (tagName === 'INPUT' && target.type === 'radio') {
//       const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
//       if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
//     }
//   }

//   getInputForEventTarget(target) {
//     return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
//   }

//   get selectedOptionValues() {
//     return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
//       ({ dataset }) => dataset.optionValueId
//     );
//   }
// }
// customElements.define('product-variant-selects', ProductVariantSelects);

// if (!customElements.get('product-info')) {
//   customElements.define(
//     "product-info",
//     class ProductInfo extends HTMLElement {
//       quantityInput = undefined;
//       quantityForm = undefined;
//       onVariantChangeUnsubscriber = undefined;
//       cartUpdateUnsubscriber = undefined;
//       abortController = undefined;
//       pendingRequestUrl = null;
//       preProcessHtmlCallbacks = [];
//       postProcessHtmlCallbacks = [];

//       constructor() {
//         super();

//         this.quantityInput = this.querySelector(".quantity__input");
//         this.productMediaGallery = this.querySelector(`[id^="MediaGallery-${this.dataset.section}"]`);
//         this.productVariantSelects = this.querySelector('product-variant-selects');
//       }

//       connectedCallback() {
//         this.initializeProductSwapUtility();

//         this.onVariantChangeUnsubscriber = subscribe(
//           PUB_SUB_EVENTS.optionValueSelectionChange,
//           this.handleOptionValueChange.bind(this)
//         );

//         this.initQuantityHandlers();
//         this.dispatchEvent(
//           new CustomEvent("product-info:loaded", { bubbles: true })
//         );
//         this.initUpdateMedia();

//         if (this.productMediaGallery && this.productMediaGallery.dataset.hideOtherVariantsMedia === 'true') {
//           this.updateVariantMedia();
//         }
//       }

//       addPreProcessCallback(callback) {
//         this.preProcessHtmlCallbacks.push(callback);
//       }

//       initQuantityHandlers() {
//         if (!this.quantityInput) return;

//         this.quantityForm = this.querySelector(
//           ".product-form__quantity"
//         );
//         if (!this.quantityForm) return;

//         this.setQuantityBoundries();
//         if (!this.dataset.originalSection) {
//           this.cartUpdateUnsubscriber = subscribe(
//             PUB_SUB_EVENTS.cartUpdate,
//             this.fetchQuantityRules.bind(this)
//           );
//         }
//       }

//       initUpdateMedia() {
//         const variantIdFromUrl = parseInt(window.location.search.split('?').filter(item => item.includes('variant='))[0]?.split('=')[1]) || null;
//         if (!variantIdFromUrl) { return; }
//         const variant = this.getSelectedVariant(this);
//         if (!variant || !variantIdFromUrl) { return; }
//         if (variant?.id === variantIdFromUrl) {
//           this.updateMedia(variant?.featured_media?.id);
//         }
//       }

//       disconnectedCallback() {
//         this.onVariantChangeUnsubscriber();
//         this.cartUpdateUnsubscriber?.();
//       }

//       initializeProductSwapUtility() {
//         this.preProcessHtmlCallbacks.push(html =>
//           html
//             .querySelectorAll(".scroll-trigger")
//             .forEach(element =>
//               element.classList.add("scroll-trigger--cancel")
//             )
//         );
//         this.postProcessHtmlCallbacks.push(newNode => {
//           window?.Shopify?.PaymentButton?.init();
//           window?.ProductModel?.loadShopifyXR();
//         });
//       }

//       handleOptionValueChange({
//         data: { event, target, selectedOptionValues }
//       }) {
//         if (!this.contains(event.target)) return;

//         this.resetProductFormState();

//         const productUrl =
//           target.dataset.productUrl ||
//           this.pendingRequestUrl ||
//           this.dataset.url;
//         this.pendingRequestUrl = productUrl;
//         const shouldSwapProduct = this.dataset.url !== productUrl;
//         const shouldFetchFullPage =
//           this.dataset.updateUrl === "true" && shouldSwapProduct;

//         this.renderProductInfo({
//           requestUrl: this.buildRequestUrlWithParams(
//             productUrl,
//             selectedOptionValues,
//             shouldFetchFullPage
//           ),
//           targetId: target.id,
//           callback: shouldSwapProduct
//             ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
//             : this.handleUpdateProductInfo(productUrl)
//         });
//       }

//       resetProductFormState() {
//         const productForm = this.productForm;
//         productForm?.toggleSubmitButton(true);
//         productForm?.handleErrorMessage();
//       }

//       handleSwapProduct(productUrl, updateFullPage) {
//         return html => {
//           this.productModal?.remove();

//           const selector = updateFullPage
//             ? "product-info[id^='MainProduct']"
//             : "product-info";
//           const variant = this.getSelectedVariant(
//             html.querySelector(selector)
//           );
//           this.updateURL(productUrl, variant?.id);

//           if (updateFullPage) {
//             document.querySelector("head title").innerHTML =
//               html.querySelector("head title").innerHTML;

//             HTMLUpdateUtility.viewTransition(
//               document.querySelector("main"),
//               html.querySelector("main"),
//               this.preProcessHtmlCallbacks,
//               this.postProcessHtmlCallbacks
//             );
//           } else {
//             HTMLUpdateUtility.viewTransition(
//               this,
//               html.querySelector("product-info"),
//               this.preProcessHtmlCallbacks,
//               this.postProcessHtmlCallbacks
//             );
//           }
//         };
//       }

//       renderProductInfo({ requestUrl, targetId, callback }) {
//         this.abortController?.abort();
//         this.abortController = new AbortController();

//         fetch(requestUrl, { signal: this.abortController.signal })
//           .then(response => response.text())
//           .then(responseText => {
//             this.pendingRequestUrl = null;
//             const html = new DOMParser().parseFromString(
//               responseText,
//               "text/html"
//             );
//             callback(html);
//           })
//           .then(() => {
//             // set focus to last clicked option value
//             document.querySelector(`#${targetId}`)?.focus();
//           })
//           .catch(error => {
//             if (error.name === "AbortError") {
//               // console.log("Fetch aborted by user");
//             } else {
//               // console.error(error);
//             }
//           });
//       }

//       getSelectedVariant(productInfoNode) {
//         const selectedVariant = productInfoNode.querySelector(
//           "product-variant-selects [data-selected-variant]"
//         )?.innerHTML;
//         return !!selectedVariant ? JSON.parse(selectedVariant) : null;
//       }

//       buildRequestUrlWithParams(
//         url,
//         optionValues,
//         shouldFetchFullPage = false
//       ) {
//         const params = [];

//         !shouldFetchFullPage &&
//           params.push(`section_id=${this.sectionId}`);

//         if (optionValues.length) {
//           params.push(`option_values=${optionValues.join(",")}`);
//         }

//         return `${url}?${params.join("&")}`;
//       }

//       updateOptionValues(html) {
//         const productVariantSelects = html.querySelector("product-variant-selects");
//         if (productVariantSelects) {
//           HTMLUpdateUtility.viewTransition(
//             this.variantSelectors,
//             productVariantSelects,
//             this.preProcessHtmlCallbacks
//           );
//         }
//       }

//       handleUpdateProductInfo(productUrl) {
//         return html => {
//           const variant = this.getSelectedVariant(html);

//           // this.pickupAvailability?.update(variant);
//           this.updateOptionValues(html);
//           this.updateURL(productUrl, variant?.id);
//           this.updateVariantInputs(variant?.id);
//           this.updateVariantDiscountBadge(variant?.price, variant?.compare_at_price);
//           this.updateVariantDetails(variant?.id);
//           // Inserted logic for pickupAvailability after updateVariantDetails
//           if (this.pickupAvailability && variant?.id) {
//             this.pickupAvailability.dataset.variantId = variant.id;
//             this.pickupAvailability.fetchAvailability(variant.id);
//           }

//           if (this.productMediaGallery && this.productMediaGallery.dataset.hideOtherVariantsMedia === 'true') {
//             this.updateVariantMedia(html);
//           }

//           if (!variant) {
//             this.setUnavailable();
//             return;
//           }

//           this.updateMedia(variant?.featured_media?.id);

//           const updateSourceFromDestination = (
//             id,
//             shouldHide = source => false
//           ) => {
//             const source = html.getElementById(`${id}-${this.sectionId}`);
//             const destination = this.querySelector(`#${id}-${this.dataset.section}`);

//             if (source && destination) {

//               destination.innerHTML = source.innerHTML;

//               if (id === 'Inventory') {
//                 const inventoryThreshold = parseInt(source.dataset.inventoryThreshold);
//                 const inventoryQuantity = parseInt(source.dataset.inventoryQuantity);
//                 destination.classList.toggle("hidden", inventoryThreshold && inventoryQuantity > inventoryThreshold || inventoryQuantity < 1);
//               } else {
//                 destination.classList.toggle("hidden", shouldHide(source));
//               }
//             }
//           };

//           updateSourceFromDestination("ProductPurchaseInfo");
//           updateSourceFromDestination("ProductStickyCart");

//           updateSourceFromDestination("price");
//           updateSourceFromDestination("Sku", ({ classList }) => classList.contains("hidden"));

//           updateSourceFromDestination("Inventory", ({ innerText }) => innerText === "");

//           this.updateQuantityRules(this.sectionId, html);
//           this.querySelector(
//             `#Quantity-Rules-${this.dataset.section}`
//           )?.classList.remove("hidden");

//           this.productForm?.toggleSubmitButton(
//             html
//               .getElementById(`ProductSubmitButton-${this.sectionId}`)
//               ?.hasAttribute("disabled") ?? true,
//             window.variantStrings.soldOut
//           );

//           publish(PUB_SUB_EVENTS.variantChange, {
//             data: {
//               sectionId: this.sectionId,
//               html,
//               variant
//             }
//           });
//         };
//       }

//       updateVariantMedia() {
//         const select_variant_options_handle = this.querySelector(
//           'product-variant-selects [data-selected-variant-options-handle]'
//         )?.innerHTML.trim();

//         if (!select_variant_options_handle) {
//           const productAllVariants = this.productVariantSelects.querySelector('[data-all-variants]').innerHTML.trim();

//           // Make sure to attach the event listener to the correct element
//           this.productVariantSelects.addEventListener('click', (event) => {
//             const closestVariantOptionInput = event.target.closest('.product-option__input');

//             // Ensure that you are finding the correct input
//             if (closestVariantOptionInput) {
//               const closestVariantOptionInputValue = closestVariantOptionInput.value;

//               // Parse productAllVariants and check for the selected variant
//               const availableVariant = JSON.parse(productAllVariants).find(variant => {
//                 return variant.options.some(option => option === closestVariantOptionInputValue);
//               });
//             } else {
//               // console.log('No variant option input found');
//             }
//           });
//         }

//         this.productMediaGallery.querySelectorAll('[data-media-group]').forEach(element => element.classList.add('hidden'));

//         this.productMediaGallery.querySelectorAll(`[data-media-group="${select_variant_options_handle}"]`).forEach(element => element.classList.remove('hidden'));

//         this.productMediaGallery.querySelectorAll('swiper-product-gallery').forEach(swiperSlide => {
//           if (swiperSlide.instance) {
//             swiperSlide.instance.update(); // Update the Swiper instance
//           } else {
//             swiperSlide.init(); // If the instance is not available, reinitialize
//           }
//         });
//       }

//       updateVariantOptionMedia() {
//         this.productMediaGallery.querySelectorAll('[data-media-group]:not(.hidden)').forEach(element => {

//         });
//       }

//       updateVariantInputs(variantId) {
//         this.querySelectorAll(
//           `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
//         ).forEach(productForm => {
//           const input = productForm.querySelector('input[name="id"]');
//           input.value = variantId ?? "";
//           input.dispatchEvent(new Event("change", { bubbles: true }));
//         });
//       }

//       updateURL(url, variantId) {
//         this.querySelector("share-button")?.updateUrl(
//           `${window.shopUrl}${url}${
//             variantId ? `?variant=${variantId}` : ""
//           }`
//         );

//         if (this.dataset.updateUrl === "false") return;
//         window.history.replaceState(
//           {},
//           "",
//           `${url}${variantId ? `?variant=${variantId}` : ""}`
//         );
//       }

//       updateSellingPlanURL(sellingPlanId, selectedVariantId) {
//         if (!selectedVariantId) return;
//         if (!sellingPlanId) {
//           window.history.replaceState({}, "", `${window.location.href.replace(/&selling_plan=\d+/, "")}`);
//         } else {
//           const params = new URLSearchParams(window.location.search);
//           params[params.has("variant") ? "set" : "append"](
//             "variant",
//             selectedVariantId
//           );
//           if (sellingPlanId) {
//             params[params.has("selling_plan") ? "set" : "append"](
//               "selling_plan",
//               sellingPlanId
//             );
//           } else {
//             params.delete("selling_plan");
//           }
//           window.history.replaceState({}, "", `${this.dataset.url}?${params.toString()}`);
//         }
//       }

//       updateVariantDetails(variantId) {
//         const productVariantDetails = this.querySelectorAll('.product__metafield_for_variant-block');
//         if (productVariantDetails) {
//           productVariantDetails.forEach((productVariantDetail) => {
//             const block_id = productVariantDetail.getAttribute('data-block-id');
//             const metafieldDataElement = this.querySelector(`#product__metafield_for_variant-block--${block_id}`);
//             if (!metafieldDataElement) {
//               return;
//             }
//             try {
//               let productVariantDetailsData = JSON.parse(metafieldDataElement?.textContent);
//               productVariantDetail.innerHTML = productVariantDetailsData?.[variantId]?.replaceAll('\n', '<br />') || '';
//             } catch (error) {
//               console.error('Error parsing JSON', error);
//             }
//           });
//         }
//       }

//       updateVariantDiscountBadge(price, compare_at_price) {
//         const discountBadge = this.querySelector(".product-card__badge--discount");
//         if (!discountBadge) return;


//         if (compare_at_price > price) {
//           discountBadge.classList.remove("hidden");
//           const percentageElement = discountBadge.querySelector(".percentage");
//           // calculate discount percentage
//           const discountPercentage = Math.round(
//             ((compare_at_price - price) / compare_at_price) * 100
//           );
//           // update discount percentage
//           percentageElement.textContent = discountPercentage;
//         } else {
//           discountBadge.classList.add("hidden");
//         }
//       }

//       setUnavailable() {
//         this.productForm?.toggleSubmitButton(
//           true,
//           window.variantStrings.unavailable
//         );

//         const selectors = [
//           "price",
//           "Inventory",
//           "Sku",
//           "Quantity-Rules"
//         ]
//           .map(id => `#${id}-${this.dataset.section}`)
//           .join(", ");
//         document
//           .querySelectorAll(selectors)
//           .forEach(({ classList }) => classList.add("hidden"));
//       }

//       updateMedia(variantFeaturedMediaId) {
//         if (!variantFeaturedMediaId) return;

//         // if layout is grid, add .active class to the relevant swiper-slide
//         const gridLayout = this.querySelector('.main-product__media--grid');
//         if (gridLayout) {
//           // remove active class from all swiper-slides
//           gridLayout.querySelectorAll('.swiper-slide').forEach(item => {
//             item.classList.remove('active');
//           });
//           // add .active class to the swiper-slide with the matching data-media-id
//           const activeSlide = gridLayout.querySelector(`.swiper-slide[data-media-id="${variantFeaturedMediaId}"]`);
//           if (activeSlide) {
//             activeSlide.classList.add('active');
//           }
//         }

//         if (
//           this.querySelector(".main-product__media")?.hasAttribute(
//             "data-desktop-grid"
//           ) && window.innerWidth >= 750
//         ) {
//           this.scrollToImage(variantFeaturedMediaId);
//         }

//         const productMedia = this.querySelector(
//           "swiper-product-gallery"
//         );
//         productMedia?.setActiveMedia(variantFeaturedMediaId);
//       }

//       scrollToImage(variantFeaturedMediaId) {
//         this.querySelectorAll("[data-media-id]").forEach(img => {
//           if (
//             img.getAttribute("data-media-id") ==
//             variantFeaturedMediaId
//           ) {
//             img.scrollIntoView({
//               block: "end",
//               behavior: "smooth"
//             });
//           }
//         });
//       }

//       setQuantityBoundries() {
//         const data = {
//           cartQuantity: this.quantityInput.dataset.cartQuantity
//             ? parseInt(this.quantityInput.dataset.cartQuantity)
//             : 0,
//           min: this.quantityInput.dataset.min
//             ? parseInt(this.quantityInput.dataset.min)
//             : 1,
//           max: this.quantityInput.dataset.max
//             ? parseInt(this.quantityInput.dataset.max)
//             : null,
//           step: this.quantityInput.step
//             ? parseInt(this.quantityInput.step)
//             : 1
//         };

//         let min = data.min;
//         const max =
//           data.max === null ? data.max : data.max - data.cartQuantity;
//         if (max !== null) min = Math.min(min, max);
//         if (data.cartQuantity >= data.min)
//           min = Math.min(min, data.step);

//         this.quantityInput.min = min;

//         if (max) {
//           this.quantityInput.max = max;
//         } else {
//           this.quantityInput.removeAttribute("max");
//         }
//         this.quantityInput.value = min;

//         publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
//       }

//       fetchQuantityRules() {
//         const currentVariantId =
//           this.productForm?.variantIdInput?.value;
//         if (!currentVariantId) return;

//         this.querySelector(
//           ".quantity__rules-cart .loading__spinner"
//         ).classList.remove("hidden");
//         fetch(
//           `${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`
//         )
//           .then(response => response.text())
//           .then(responseText => {
//             const html = new DOMParser().parseFromString(
//               responseText,
//               "text/html"
//             );
//             this.updateQuantityRules(this.dataset.section, html);
//           })
//           .catch(e => console.error(e))
//           .finally(() =>
//             this.querySelector(
//               ".quantity__rules-cart .loading__spinner"
//             ).classList.add("hidden")
//           );
//       }

//       updateQuantityRules(sectionId, html) {
//         if (!this.quantityInput) return;
//         this.setQuantityBoundries();

//         const quantityFormUpdated = html.getElementById(
//           `Quantity-Form-${sectionId}`
//         );
//         const selectors = [
//           ".quantity__input",
//           ".quantity__rules",
//           ".quantity__label"
//         ];
//         for (let selector of selectors) {
//           const current = this.quantityForm.querySelector(selector);
//           const updated = quantityFormUpdated.querySelector(selector);
//           if (!current || !updated) continue;
//           if (selector === ".quantity__input") {
//             const attributes = [
//               "data-cart-quantity",
//               "data-min",
//               "data-max",
//               "step"
//             ];
//             for (let attribute of attributes) {
//               const valueUpdated = updated.getAttribute(attribute);
//               if (valueUpdated !== null) {
//                 current.setAttribute(attribute, valueUpdated);
//               } else {
//                 current.removeAttribute(attribute);
//               }
//             }
//           } else {
//             current.innerHTML = updated.innerHTML;
//           }
//         }
//       }

//       get productForm() {
//         return this.querySelector(`product-form`);
//       }

//       get productModal() {
//         return document.querySelector(
//           `#ProductModal-${this.dataset.section}`
//         );
//       }

//       get pickupAvailability() {
//         return this.querySelector(`pickup-availability`);
//       }

//       get variantSelectors() {
//         return this.querySelector("product-variant-selects");
//       }

//       get relatedProducts() {
//         const relatedProductsSectionId = SectionId.getIdForSection(
//           SectionId.parseId(this.sectionId),
//           "related-products"
//         );
//         return document.querySelector(
//           `product-recommendations[data-section-id^="${relatedProductsSectionId}"]`
//         );
//       }

//       get quickOrderList() {
//         const quickOrderListSectionId = SectionId.getIdForSection(
//           SectionId.parseId(this.sectionId),
//           "quick_order_list"
//         );
//         return document.querySelector(
//           `quick-order-list[data-id^="${quickOrderListSectionId}"]`
//         );
//       }

//       get sectionId() {
//         return this.dataset.originalSection || this.dataset.section;
//       }
//     }
//   );
// }

// if (!customElements.get('product-form')) {
//   customElements.define(
//     "product-form",
//     class ProductForm extends HTMLElement {
//       constructor() {
//         super();

//         this.form = this.querySelector("form");
//         this.variantIdInput.disabled = false;
//         this.form.addEventListener(
//           "submit",
//           this.onSubmitHandler.bind(this)
//         );
//         this.cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
//         this.submitButton = this.querySelector('[type="submit"]');
//         this.submitButtonText =
//           this.submitButton.querySelector("span");

//         if (document.querySelector("cart-drawer"))
//           this.submitButton.setAttribute("aria-haspopup", "dialog");

//         this.hideErrors = this.dataset.hideErrors === "true";
//       }

//       onSubmitHandler(evt) {
//         evt.preventDefault();
//         if (
//           this.submitButton.getAttribute("aria-disabled") === "true"
//         )
//           return;

//         this.handleErrorMessage();

//         this.submitButton.setAttribute("aria-disabled", true);
//         this.submitButton.classList.add("loading");
//         this.querySelector(".loading__spinner").classList.remove(
//           "hidden"
//         );

//         const config = fetchConfig("javascript");
//         config.headers["X-Requested-With"] = "XMLHttpRequest";
//         delete config.headers["Content-Type"];

//         const formData = new FormData(this.form);
//         if (this.cart) {
//           formData.append(
//             "sections",
//             this.cart
//               .getSectionsToRender()
//               .map(section => section.section)
//           );
//           formData.append("sections_url", window.location.pathname);
//           this.cart.setActiveElement(document.activeElement);
//         }
//         config.body = formData;

//         fetch(`${routes.cart_add_url}`, config)
//           .then(response => response.json())
//           .then(response => {
//             if (response.status) {
//               publish(PUB_SUB_EVENTS.cartError, {
//                 source: "product-form",
//                 productVariantId: formData.get("id"),
//                 errors: response.errors || response.description,
//                 message: response.message
//               });
//               this.handleErrorMessage(response.description);

//               const soldOutMessage = this.submitButton.querySelector(
//                 ".sold-out-message"
//               );
//               if (!soldOutMessage) return;
//               this.submitButton.setAttribute("aria-disabled", true);
//               this.submitButtonText.classList.add("hidden");
//               soldOutMessage.classList.remove("hidden");
//               this.error = true;
//               return;
//             } else if (!this.cart) {
//               window.location = window.routes.cart_url;
//               return;
//             }

//             if (!this.error)
//               publish(PUB_SUB_EVENTS.cartUpdate, {
//                 source: "product-form",
//                 productVariantId: formData.get("id"),
//                 cartData: response
//               });
//             this.error = false;
//             this.cart.renderContents(response);
//           })
//           .catch(e => {
//             console.error(e);
//           })
//           .finally(() => {
//             this.submitButton.classList.remove("loading");
//             if (this.cart && this.cart.classList.contains("is-empty"))
//               this.cart.classList.remove("is-empty");
//             if (!this.error)
//               this.submitButton.removeAttribute("aria-disabled");
//             this.querySelector(".loading__spinner").classList.add(
//               "hidden"
//             );
//           });
//       }

//       handleErrorMessage(errorMessage = false) {
//         if (this.hideErrors) return;

//         this.errorMessageWrapper =
//           this.errorMessageWrapper ||
//           this.querySelector(".product-form__error-message-wrapper");
//         if (!this.errorMessageWrapper) return;
//         this.errorMessage =
//           this.errorMessage ||
//           this.errorMessageWrapper.querySelector(
//             ".product-form__error-message"
//           );

//         this.errorMessageWrapper.toggleAttribute(
//           "hidden",
//           !errorMessage
//         );

//         if (errorMessage) {
//           this.errorMessage.textContent = errorMessage;
//         }
//       }

//       toggleSubmitButton(disable = true, text) {
//         if (disable) {
//           this.submitButton.setAttribute("disabled", "disabled");
//           if (text) this.submitButtonText.textContent = text;
//         } else {
//           this.submitButton.removeAttribute("disabled");
//           this.submitButtonText.textContent = this.hasAttribute(
//             "data-has-selling-plan"
//           )
//             ? window.variantStrings.addSubscriptionToCart
//             : this.submitButtonText.textContent = this.hasAttribute(
//                 "data-has-pre-order"
//               )
//             ?  window.variantStrings.preOrder
//             : window.variantStrings.addToCart;
//         }
//       }

//       get variantIdInput() {
//         return this.form.querySelector("[name=id]");
//       }
//     }
//   );
// }

// document.querySelectorAll('.product__content > *').forEach((el) => {
//   if (!el.textContent.trim()) {
//     el.textContent = '';
//   }
// });
class HTMLUpdateUtility {
  /**
   * Used to swap an HTML node with a new node.
   * The new node is inserted as a previous sibling to the old node, the old node is hidden, and then the old node is removed.
   *
   * The function currently uses a double buffer approach, but this should be replaced by a view transition once it is more widely supported https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
   */
  static viewTransition(oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) {
    preProcessCallbacks?.forEach((callback) => callback(newContent));

    const newNodeWrapper = document.createElement('div');
    HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
    const newNode = newNodeWrapper.firstChild;

    // dedupe IDs
    const uniqueKey = Date.now();
    oldNode.querySelectorAll('[id], [form]').forEach((element) => {
      element.id && (element.id = `${element.id}-${uniqueKey}`);
      element.form && element.setAttribute('form', `${element.form.getAttribute('id')}-${uniqueKey}`);
    });

    oldNode.parentNode.insertBefore(newNode, oldNode);
    oldNode.style.display = 'none';

    postProcessCallbacks?.forEach((callback) => callback(newNode));

    setTimeout(() => oldNode.remove(), 500);
  }

  // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
  static setInnerHTML(element, html) {
    element.innerHTML = html;
    element.querySelectorAll('script').forEach((oldScriptTag) => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}

class QuantityInputDawn extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    if (event.target.name === 'plus') {
      if (parseInt(this.input.dataset.min) > parseInt(this.input.step) && this.input.value == 0) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

    if (this.input.dataset.min === previousValue && event.target.name === 'minus') {
      this.input.value = parseInt(this.input.min);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', parseInt(value) <= parseInt(this.input.min));
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input-dawn', QuantityInputDawn);

class ProductVariantSelects extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('change', (event) => {
      const target = this.getInputForEventTarget(event.target);
      this.updateSelectionMetadata(event);

      publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
        data: {
          event,
          target,
          selectedOptionValues: this.selectedOptionValues,
        },
      });
    });
  }

  updateSelectionMetadata({ target }) {
    const { value, tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {

      Array.from(target.options)
        .find((option) => option.getAttribute('selected'))
        .removeAttribute('selected');

      // change previous target.selectedOptions with new value
      const newSelectedOption = Array.from(target.options).find((option) => option.value === value);
      if (newSelectedOption) {
        newSelectedOption.setAttribute('selected', 'selected');
      }

      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = target
        .closest('.product-form__input')
        .querySelector('[data-selected-value] > .product-option__swatch');
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('product-option__swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('product-option__swatch--unavailable');
      }

      selectedDropdownSwatchValue.style.setProperty(
        '--swatch-focal-point',
        target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
      );
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  getInputForEventTarget(target) {
    return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
  }

  get selectedOptionValues() {
    return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
      ({ dataset }) => dataset.optionValueId
    );
  }
}
customElements.define('product-variant-selects', ProductVariantSelects);

if (!customElements.get('product-info')) {
  customElements.define(
    "product-info",
    class ProductInfo extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];
      _mediaUpdateToken = 0;

      constructor() {
        super();

        this.quantityInput = this.querySelector(".quantity__input");
        this.productMediaGallery = this.querySelector(`[id^="MediaGallery-${this.dataset.section}"]`);
        this.productVariantSelects = this.querySelector('product-variant-selects');
      }

      connectedCallback() {
        this.initializeProductSwapUtility();

        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );

        this.initQuantityHandlers();
        this.dispatchEvent(
          new CustomEvent("product-info:loaded", { bubbles: true })
        );
        this.bindThumbClickSync();

        // Filter the thumbs/slider/grid down to the initially-selected
        // variant's own photos on first paint - without this, the page
        // loads with every color's photos mixed into the thumbs strip
        // until the first variant switch ever runs updateMediaSlides().
        //
        // ORDER FIX: this must run BEFORE initUpdateMedia(). Reason: on a
        // direct page load to a `?variant=...` URL, initUpdateMedia() waits
        // for swiper-product-gallery to be ready via whenGalleryReady(). If
        // the Swiper instance is ALREADY ready at this point (common on
        // page load), whenGalleryReady() runs its callback synchronously,
        // immediately - meaning updateMedia()/setActiveMedia() would fire
        // against the full, unfiltered, multi-color slide set. Then, right
        // after, updateMediaSlides() removes the non-matching slides,
        // shifting Swiper's slide count/index and knocking the just-set
        // active slide onto the wrong (often last) one. Filtering first
        // guarantees the active slide is set against the FINAL slide count.
        this.updateMediaSlides(this.getSelectedVariant(this));
        this.initUpdateMedia();


        if (this.productMediaGallery && this.productMediaGallery.dataset.hideOtherVariantsMedia === 'true') {
          this.updateVariantMedia();
        }
      }

      /**
       * FIX for: clicking a thumb (e.g. data-alt-op="COLOR_BLACK") shows the
       * WRONG slide in the main slider (e.g. COLOR_BLACK-GARNET) - happens
       * only on mobile.
       *
       * Cause: the mobile main-slider <-> thumbs sync relies on Swiper's
       * built-in index-based thumb linking (index N in thumbs jumps to
       * index N in the main slider). That assumption breaks the instant the
       * main slider and thumbs strip aren't in perfectly identical
       * order/count - which happens here because grid/slider/thumbs markup
       * are swapped independently in updateVariantMedia() and slides can
       * carry data-alt-op filtering. Desktop never shows this bug because
       * updateMedia() there navigates by data-media-id directly instead of
       * relying on index sync.
       *
       * Fix: every slide AND every thumb already carries the same stable
       * data-media-id="{{ media.id }}". Delegate click on the thumbs strip,
       * resolve the clicked thumb's data-media-id, and call
       * setActiveMedia(mediaId) directly - bypassing index math entirely.
       * Bound once, in the capture phase, so it wins the race even if the
       * component's own (index-based) click handler is already attached.
       */
      bindThumbClickSync() {
        if (!this.productMediaGallery || this.productMediaGallery.dataset.thumbSyncBound === 'true') return;
        this.productMediaGallery.dataset.thumbSyncBound = 'true';

        this.productMediaGallery.addEventListener('click', (event) => {
          const thumbSlide = event.target.closest(
            '.main-product__media--thumbs-wrapper .swiper-slide[data-media-id]'
          );
          if (!thumbSlide) return;

          const mediaId = thumbSlide.dataset.mediaId;
          if (!mediaId) return;

          // Stop the built-in index-based thumb->slider link from also
          // firing and potentially landing on the wrong slide afterwards.
          event.stopImmediatePropagation();

          const productMedia = this.querySelector('swiper-product-gallery');
          productMedia?.setActiveMedia(mediaId);
        }, true);
      }

      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.quantityForm = this.querySelector(
          ".product-form__quantity"
        );
        if (!this.quantityForm) return;

        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(
            PUB_SUB_EVENTS.cartUpdate,
            this.fetchQuantityRules.bind(this)
          );
        }
      }

      /**
       * Resolves the correct media id to activate for a variant.
       *
       * FIX: Shopify's variant JSON (as dumped into data-selected-variant
       * via `{{ variant | json }}`) carries `featured_image`, NOT
       * `featured_media` - `featured_media` only exists as a Liquid-object
       * property, not on the serialized variant. Every call site here was
       * reading `variant.featured_media?.id`, which was always undefined,
       * so setActiveMedia() never actually ran on any AJAX variant switch -
       * that's the real cause of the gallery always landing on the last
       * slide (nothing ever told Swiper the correct target, so it just
       * clamped its previous/stale index to the new last valid slide once
       * updateMediaSlides() shrank the slide count).
       */
      getFeaturedMediaId(variant) {
        return variant?.featured_media?.id ?? variant?.featured_image?.id ?? null;
      }

      initUpdateMedia() {
        const variantIdFromUrl = parseInt(window.location.search.split('?').filter(item => item.includes('variant='))[0]?.split('=')[1]) || null;
        if (!variantIdFromUrl) { return; }
        const variant = this.getSelectedVariant(this);
        if (!variant || !variantIdFromUrl) { return; }
        if (variant?.id === variantIdFromUrl) {
          // Don't call this immediately - swiper-product-gallery's own Swiper
          // instance may not exist yet at this point in connectedCallback.
          // Poll (via rAF) until it's ready, same as the variant-change path.
          this.whenGalleryReady(() => this.updateMedia(this.getFeaturedMediaId(variant)));
        }

      }

      /**
       * Polls (via requestAnimationFrame) until the swiper-product-gallery
       * custom element has finished constructing its internal Swiper
       * instance, then runs callback. Falls back to just running the
       * callback after a bounded number of attempts, so we never hang
       * forever if this element ever changes its readiness signal.
       */
      whenGalleryReady(callback, attemptsLeft = 20) {
        const gallery = this.querySelector('swiper-product-gallery');
        if (!gallery) return; // no swiper gallery in this layout (e.g. grid-only)
        if (gallery.instance || attemptsLeft <= 0) {
          callback();
          return;
        }
        requestAnimationFrame(() => this.whenGalleryReady(callback, attemptsLeft - 1));
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
      }

      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push(html =>
          html
            .querySelectorAll(".scroll-trigger")
            .forEach(element =>
              element.classList.add("scroll-trigger--cancel")
            )
        );
        this.postProcessHtmlCallbacks.push(newNode => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      handleOptionValueChange({
        data: { event, target, selectedOptionValues }
      }) {
        if (!this.contains(event.target)) return;

        this.resetProductFormState();

        const productUrl =
          target.dataset.productUrl ||
          this.pendingRequestUrl ||
          this.dataset.url;
        this.pendingRequestUrl = productUrl;
        const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldFetchFullPage =
          this.dataset.updateUrl === "true" && shouldSwapProduct;

        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(
            productUrl,
            selectedOptionValues,
            shouldFetchFullPage
          ),
          targetId: target.id,
          callback: shouldSwapProduct
            ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
            : this.handleUpdateProductInfo(productUrl)
        });
      }

      resetProductFormState() {
        const productForm = this.productForm;
        productForm?.toggleSubmitButton(true);
        productForm?.handleErrorMessage();
      }

      handleSwapProduct(productUrl, updateFullPage) {
        return html => {
          this.productModal?.remove();

          const selector = updateFullPage
            ? "product-info[id^='MainProduct']"
            : "product-info";
          const variant = this.getSelectedVariant(
            html.querySelector(selector)
          );
          this.updateURL(productUrl, variant?.id);
          if (updateFullPage) {
            document.querySelector("head title").innerHTML =
              html.querySelector("head title").innerHTML;

            HTMLUpdateUtility.viewTransition(
              document.querySelector("main"),
              html.querySelector("main"),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector("product-info"),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }
        };
      }

      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(requestUrl, { signal: this.abortController.signal })
          .then(response => response.text())
          .then(responseText => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(
              responseText,
              "text/html"
            );
            callback(html);
          })
          .then(() => {
            // set focus to last clicked option value
            document.querySelector(`#${targetId}`)?.focus();
          })
          .catch(error => {
            if (error.name === "AbortError") {
              // console.log("Fetch aborted by user");
            } else {
              // console.error(error);
            }
          });
      }

      getSelectedVariant(productInfoNode) {
        const selectedVariant = productInfoNode.querySelector(
          "product-variant-selects [data-selected-variant]"
        )?.innerHTML;
        return !!selectedVariant ? JSON.parse(selectedVariant) : null;
      }

      buildRequestUrlWithParams(
        url,
        optionValues,
        shouldFetchFullPage = false
      ) {
        const params = [];

        !shouldFetchFullPage &&
          params.push(`section_id=${this.sectionId}`);

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(",")}`);
        }

        return `${url}?${params.join("&")}`;
      }

      updateOptionValues(html) {
        const productVariantSelects = html.querySelector("product-variant-selects");
        if (productVariantSelects) {
          HTMLUpdateUtility.viewTransition(
            this.variantSelectors,
            productVariantSelects,
            this.preProcessHtmlCallbacks
          );
        }
      }

      handleUpdateProductInfo(productUrl) {
        return html => {
          const variant = this.getSelectedVariant(html);

          // this.pickupAvailability?.update(variant);
          this.updateOptionValues(html);
          this.updateURL(productUrl, variant?.id);
          this.updateVariantInputs(variant?.id);
          this.updateVariantDiscountBadge(variant?.price, variant?.compare_at_price);
          this.updateVariantDetails(variant?.id);
          this.updateVariantMedia(html, variant);
          if (this.productMediaGallery && this.productMediaGallery.dataset.hideOtherVariantsMedia === 'true') {
          }

          if (!variant) {
            this.setUnavailable();
            return;
          }

          const updateSourceFromDestination = (
            id,
            shouldHide = source => false
          ) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const destination = this.querySelector(`#${id}-${this.dataset.section}`);

            if (source && destination) {

              destination.innerHTML = source.innerHTML;

              if (id === 'Inventory') {
                const inventoryThreshold = parseInt(source.dataset.inventoryThreshold);
                const inventoryQuantity = parseInt(source.dataset.inventoryQuantity);
                destination.classList.toggle("hidden", inventoryThreshold && inventoryQuantity > inventoryThreshold || inventoryQuantity < 1);
              } else {
                destination.classList.toggle("hidden", shouldHide(source));
              }
            }
          };

          updateSourceFromDestination("ProductPurchaseInfo");
          updateSourceFromDestination("ProductStickyCart");

          updateSourceFromDestination("price");
          updateSourceFromDestination("Sku", ({ classList }) => classList.contains("hidden"));

          updateSourceFromDestination("Inventory", ({ innerText }) => innerText === "");

          this.updateQuantityRules(this.sectionId, html);
          this.querySelector(
            `#Quantity-Rules-${this.dataset.section}`
          )?.classList.remove("hidden");

          this.productForm?.toggleSubmitButton(
            html
              .getElementById(`ProductSubmitButton-${this.sectionId}`)
              ?.hasAttribute("disabled") ?? true,
            window.variantStrings.soldOut
          );
          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant
            }
          });
        };
      }

      /**
       * Swaps the grid / slider / thumbs media DOM for the new variant, then
       * (once Swiper has actually re-initialized against the NEW slides)
       * activates the correct featured slide.
       *
       * RACE-CONDITION GUARD: every call gets a token from an incrementing
       * counter. The deferred work (inside setTimeout/rAF) checks that its
       * token is still the latest before touching the DOM or calling
       * setActiveMedia(). Without this, two variant switches fired close
       * together (fast double-tap, or a swipe that also re-triggers a
       * swatch selection) each schedule their own independent timeout with
       * nothing to cancel the other - whichever timeout happens to resolve
       * LAST wins, regardless of which variant was actually selected last.
       * That's what caused the gallery to randomly land on the last slide,
       * or for the whole variant (SKU/color label included) to revert to
       * an earlier selection after a fast interaction.
       */
      updateVariantMedia(html, variant) {
        const token = ++this._mediaUpdateToken;
        const doc = html;

        const newGrid = doc.querySelector('.main-product__media--grid');
        const currentGrid = this.productMediaGallery.querySelector('.main-product__media--grid');
        if (newGrid && currentGrid) {
          currentGrid.replaceWith(newGrid);
        }

        const newSlider = doc.querySelector('.main-product__media--slider-wrapper');
        const currentSlider = this.productMediaGallery.querySelector('.main-product__media--slider-wrapper');
        if (newSlider && currentSlider) {
          currentSlider.replaceWith(newSlider);
        } else if (!newSlider || !currentSlider) {
          // Selector mismatch is the #1 cause of "slider doesn't update on mobile" -
          // if this ever logs, the mobile markup uses a different wrapper class.
          console.warn('[product-media] slider wrapper not matched', { newSlider: !!newSlider, currentSlider: !!currentSlider });
        }

        const newThumbs = doc.querySelector('.main-product__media--thumbs-wrapper');
        const currentThumbs = this.productMediaGallery.querySelector('.main-product__media--thumbs-wrapper');
        if (newThumbs && currentThumbs) {
          currentThumbs.replaceWith(newThumbs);
        }

        setTimeout(() => {
          requestAnimationFrame(() => {
            // Bail if a newer variant switch has started since this one was
            // scheduled - prevents a stale/slower update from stomping the
            // most recent selection.
            if (token !== this._mediaUpdateToken) return;

            // Filter grid/slider/thumbs down to THIS variant's own photos
            // before Swiper measures/reinitializes - must run before init,
            // not after, so Swiper's slide count reflects only what should
            // actually be reachable for this color. Passing `variant` lets
            // updateMediaSlides() protect its featured_media slide from
            // being deleted even if that slide's own data-alt-op doesn't
            // match (see the fix note inside updateMediaSlides).
            this.updateMediaSlides(variant);

            this.productMediaGallery.querySelectorAll('swiper-product-thumbs')
              .forEach(swiper => {
                if (swiper.instance) {
                  swiper.instance.destroy(true, true);
                }
                swiper.style.display = 'none';
                swiper.offsetHeight;
                swiper.style.display = '';
                if (typeof swiper.init === 'function') {
                  swiper.init();
                }
              });

            this.productMediaGallery.querySelectorAll('swiper-product-gallery')
              .forEach(swiper => {
                if (swiper.instance) {
                  swiper.instance.destroy(true, true);
                }
                swiper.style.display = 'none';
                swiper.offsetHeight;
                swiper.style.display = '';
                if (typeof swiper.init === 'function') {
                  swiper.init();
                }
              });

            // Only now that reinit is guaranteed complete, activate the
            // correct hero slide for this variant's featured media - but
            // check the token again first, since whenGalleryReady's poll
            // is itself async and a newer switch could start while it waits.
            if (variant) {
              this.whenGalleryReady(() => {
                if (token !== this._mediaUpdateToken) return;
                this.updateMedia(this.getFeaturedMediaId(variant));
              });
            }
          });
        }, 50);
      }

      /**
       * Removes swiper-slides whose data-alt-op doesn't match the currently
       * selected color/option-with-images, from grid, slider, AND thumbs.
       *
       * IMPORTANT: this REMOVES non-matching slides from the DOM rather than
       * hiding them with a CSS class. Hiding via display:none still leaves
       * them counted in Swiper's internal slide array/index, which is what
       * caused variant switches to sometimes land on the last slide instead
       * of the correct featured slide - Swiper's index math was running
       * against a slide count that included invisible slides mixed in with
       * real ones. Actually removing them guarantees Swiper only ever sees
       * the current variant's real slide count. This is safe because every
       * variant switch re-fetches the FULL, unfiltered multi-color photoset
       * fresh from the server via updateVariantMedia()'s replaceWith - so
       * removed slides simply come back on the next switch's fresh HTML.
       *
       * @param {Object} [variant] - the newly selected variant. Its
       *   featured_media.id is always protected from removal (see below).
       *
       * FIXED:
       *  - scoped to `this` / `this.productMediaGallery` instead of `document`,
       *    so this never touches another product-info instance (e.g. a sticky
       *    cart or quick-view gallery elsewhere on the page) and always reads
       *    the option input that belongs to THIS product form.
       *  - only matches inputs that actually carry a `data-op` attribute
       *    (color/media-linked options), so a Size radio (also `:checked`)
       *    can't accidentally get compared against `data-alt-op`.
       *  - NEVER removes the variant's own featured_media slide, even if its
       *    data-alt-op doesn't match the selected option's data-op. This was
       *    the actual cause of "every variant except the first lands on the
       *    last slide": whenever a variant's real featured photo's alt-text
       *    tag didn't line up exactly with the option's data-op format, this
       *    filter was deleting that slide outright before setActiveMedia()
       *    ever got a chance to activate it - so there was nothing correct
       *    left in the DOM to land on, and it fell back to the last slide.
       *    The default/first variant only "worked" because its featured
       *    photo likely has no "#" in its alt text at all, so it never had a
       *    data-alt-op tag to mismatch on in the first place.
       */
      updateMediaSlides(variant) {
        const selectedInput = this.querySelector('.product-option__input[data-op]:checked');
        const selectedOp = selectedInput?.dataset.op?.toUpperCase();

        // No color/media-linked option selected (or none exists) - nothing
        // to filter, leave every slide as-is.
        if (!selectedOp) return;

        const resolvedFeaturedMediaId = this.getFeaturedMediaId(variant);
        const featuredMediaId = resolvedFeaturedMediaId != null
          ? String(resolvedFeaturedMediaId)
          : null;

        const slides = this.productMediaGallery.querySelectorAll(
          '.swiper-slide[data-alt-op]'
        );

        slides.forEach(slide => {
          if (featuredMediaId && slide.dataset.mediaId === featuredMediaId) {
            // This is the slide we're about to activate - always keep it.
            return;
          }

          const slideAltOp = slide.dataset.altOp?.toUpperCase();
          if (slideAltOp !== selectedOp) {
            slide.remove();
          }
        });

        const submitBtn = this.querySelector('.product-form__submit');
        const paymentBtn = this.querySelector('.shopify-payment-button');
        const appBtn = this.querySelector('.app-button');

        if (submitBtn) {
          const disabled = submitBtn.disabled;
          submitBtn.classList.toggle('hidden', disabled);
          if (paymentBtn) paymentBtn.classList.toggle('hidden', disabled);
          if (appBtn) appBtn.classList.toggle('hidden', !disabled);
        }

        const variantInput = this.querySelector('.product-variant-id');
        const appButton = this.querySelector('.app-button');
        if (variantInput && appButton) {
          appButton.setAttribute('data-variant', variantInput.value);
        }
      }

      updateVariantOptionMedia() {
        this.productMediaGallery.querySelectorAll('[data-media-group]:not(.hidden)').forEach(element => {

        });
      }

      updateVariantInputs(variantId) {
        this.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
        ).forEach(productForm => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = variantId ?? "";
          input.dispatchEvent(new Event("change", { bubbles: true }));
        });
      }

      updateURL(url, variantId) {
        this.querySelector("share-button")?.updateUrl(
          `${window.shopUrl}${url}${
            variantId ? `?variant=${variantId}` : ""
          }`
        );
        if (this.dataset.updateUrl === "false") return;
        window.history.replaceState(
          {},
          "",
          `${url}${variantId ? `?variant=${variantId}` : ""}`
        );
      }

      updateSellingPlanURL(sellingPlanId, selectedVariantId) {
        if (!selectedVariantId) return;
        if (!sellingPlanId) {
          window.history.replaceState({}, "", `${window.location.href.replace(/&selling_plan=\d+/, "")}`);
        } else {
          const params = new URLSearchParams(window.location.search);
          params[params.has("variant") ? "set" : "append"](
            "variant",
            selectedVariantId
          );
          if (sellingPlanId) {
            params[params.has("selling_plan") ? "set" : "append"](
              "selling_plan",
              sellingPlanId
            );
          } else {
            params.delete("selling_plan");
          }
          window.history.replaceState({}, "", `${this.dataset.url}?${params.toString()}`);
        }
      }

      updateVariantDetails(variantId) {
        const productVariantDetails = this.querySelectorAll('.product__metafield_for_variant-block');
        if (productVariantDetails) {
          productVariantDetails.forEach((productVariantDetail) => {
            const block_id = productVariantDetail.getAttribute('data-block-id');
            const metafieldDataElement = this.querySelector(`#product__metafield_for_variant-block--${block_id}`);
            if (!metafieldDataElement) {
              return;
            }
            try {
              let productVariantDetailsData = JSON.parse(metafieldDataElement?.textContent);
              productVariantDetail.innerHTML = productVariantDetailsData?.[variantId]?.replaceAll('\n', '<br />') || '';
            } catch (error) {
              console.error('Error parsing JSON', error);
            }
          });
        }
      }

      updateVariantDiscountBadge(price, compare_at_price) {
        const discountBadge = this.querySelector(".product-card__badge--discount");
        if (!discountBadge) return;


        if (compare_at_price > price) {
          discountBadge.classList.remove("hidden");
          const percentageElement = discountBadge.querySelector(".percentage");
          // calculate discount percentage
          const discountPercentage = Math.round(
            ((compare_at_price - price) / compare_at_price) * 100
          );
          // update discount percentage
          percentageElement.textContent = discountPercentage;
        } else {
          discountBadge.classList.add("hidden");
        }
      }

      setUnavailable() {
        this.productForm?.toggleSubmitButton(
          true,
          window.variantStrings.unavailable
        );

        const selectors = [
          "price",
          "Inventory",
          "Sku",
          "Quantity-Rules"
        ]
          .map(id => `#${id}-${this.dataset.section}`)
          .join(", ");
        document
          .querySelectorAll(selectors)
          .forEach(({ classList }) => classList.add("hidden"));
      }

      updateMedia(variantFeaturedMediaId) {
        if (!variantFeaturedMediaId) return;

        // if layout is grid, add .active class to the relevant swiper-slide
        const gridLayout = this.querySelector('.main-product__media--grid');
        if (gridLayout) {
          gridLayout.querySelectorAll('.swiper-slide').forEach(item => {
            item.classList.remove('active');
          });
          const activeSlide = gridLayout.querySelector(`.swiper-slide[data-media-id="${variantFeaturedMediaId}"]`);
          if (activeSlide) {
            activeSlide.classList.add('active');
          }
        }

        if (
          this.querySelector(".main-product__media")?.hasAttribute(
            "data-desktop-grid"
          ) && window.innerWidth >= 750
        ) {
          this.scrollToImage(variantFeaturedMediaId);
        }

        const productMedia = this.querySelector(
          "swiper-product-gallery"
        );
        productMedia?.setActiveMedia(variantFeaturedMediaId);
      }

      scrollToImage(variantFeaturedMediaId) {
        this.querySelectorAll("[data-media-id]").forEach(img => {
          if (
            img.getAttribute("data-media-id") ==
            variantFeaturedMediaId
          ) {
            img.scrollIntoView({
              block: "end",
              behavior: "smooth"
            });
          }
        });
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity
            ? parseInt(this.quantityInput.dataset.cartQuantity)
            : 0,
          min: this.quantityInput.dataset.min
            ? parseInt(this.quantityInput.dataset.min)
            : 1,
          max: this.quantityInput.dataset.max
            ? parseInt(this.quantityInput.dataset.max)
            : null,
          step: this.quantityInput.step
            ? parseInt(this.quantityInput.step)
            : 1
        };

        let min = data.min;
        const max =
          data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min)
          min = Math.min(min, data.step);

        this.quantityInput.min = min;

        if (max) {
          this.quantityInput.max = max;
        } else {
          this.quantityInput.removeAttribute("max");
        }
        this.quantityInput.value = min;

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        const currentVariantId =
          this.productForm?.variantIdInput?.value;
        if (!currentVariantId) return;

        this.querySelector(
          ".quantity__rules-cart .loading__spinner"
        ).classList.remove("hidden");
        fetch(
          `${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`
        )
          .then(response => response.text())
          .then(responseText => {
            const html = new DOMParser().parseFromString(
              responseText,
              "text/html"
            );
            this.updateQuantityRules(this.dataset.section, html);
          })
          .catch(e => console.error(e))
          .finally(() =>
            this.querySelector(
              ".quantity__rules-cart .loading__spinner"
            ).classList.add("hidden")
          );
      }

      updateQuantityRules(sectionId, html) {
        if (!this.quantityInput) return;
        this.setQuantityBoundries();

        const quantityFormUpdated = html.getElementById(
          `Quantity-Form-${sectionId}`
        );
        const selectors = [
          ".quantity__input",
          ".quantity__rules",
          ".quantity__label"
        ];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === ".quantity__input") {
            const attributes = [
              "data-cart-quantity",
              "data-min",
              "data-max",
              "step"
            ];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }

      get productForm() {
        return this.querySelector(`product-form`);
      }

      get productModal() {
        return document.querySelector(
          `#ProductModal-${this.dataset.section}`
        );
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get variantSelectors() {
        return this.querySelector("product-variant-selects");
      }

      get relatedProducts() {
        const relatedProductsSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          "related-products"
        );
        return document.querySelector(
          `product-recommendations[data-section-id^="${relatedProductsSectionId}"]`
        );
      }

      get quickOrderList() {
        const quickOrderListSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          "quick_order_list"
        );
        return document.querySelector(
          `quick-order-list[data-id^="${quickOrderListSectionId}"]`
        );
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    }
  );
}

if (!customElements.get('product-form')) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.variantIdInput.disabled = false;
        this.form.addEventListener(
          "submit",
          this.onSubmitHandler.bind(this)
        );
        this.cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText =
          this.submitButton.querySelector("span");

        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (
          this.submitButton.getAttribute("aria-disabled") === "true"
        )
          return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading__spinner").classList.remove(
          "hidden"
        );

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart
              .getSectionsToRender()
              .map(section => section.section)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then(response => response.json())
          .then(response => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector(
                ".sold-out-message"
              );
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButtonText.classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
                cartData: response
              });
            this.error = false;
            this.cart.renderContents(response);
          })
          .catch(e => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error)
              this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading__spinner").classList.add(
              "hidden"
            );
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute(
          "hidden",
          !errorMessage
        );

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute("disabled", "disabled");
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute("disabled");
          this.submitButtonText.textContent = this.hasAttribute(
            "data-has-selling-plan"
          )
            ? window.variantStrings.addSubscriptionToCart
            : this.submitButtonText.textContent = this.hasAttribute(
                "data-has-pre-order"
              )
            ?  window.variantStrings.preOrder
            : window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector("[name=id]");
      }
    }
  );
}

function isVisible(el) {
  return el && el.offsetWidth > 0 && el.offsetHeight > 0;
}

/* =========================
✅ AUTO SELECT SIZE (FIXED)
========================= */

function autoSelectFirstAvailableSize() {
  const sizeInputs = document.querySelectorAll('.product-option__input[name*="Size"]');
  if (!sizeInputs.length) return;
  let validSelected = null;

  sizeInputs.forEach(input => {
    if (input.checked && isVisible(input)) {
      validSelected = input;
    }
  });

  if (!validSelected) {
    const firstVisible = Array.from(sizeInputs).find(input => isVisible(input));
    if (firstVisible) {
      firstVisible.click();
    }
  }
}
subscribe(PUB_SUB_EVENTS.variantChange, event => {
  autoSelectFirstAvailableSize();
});
// class HTMLUpdateUtility {
//   /**
//    * Used to swap an HTML node with a new node.
//    * The new node is inserted as a previous sibling to the old node, the old node is hidden, and then the old node is removed.
//    *
//    * The function currently uses a double buffer approach, but this should be replaced by a view transition once it is more widely supported https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
//    */
//   static viewTransition(oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) {
//     preProcessCallbacks?.forEach((callback) => callback(newContent));

//     const newNodeWrapper = document.createElement('div');
//     HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
//     const newNode = newNodeWrapper.firstChild;

//     // dedupe IDs
//     const uniqueKey = Date.now();
//     oldNode.querySelectorAll('[id], [form]').forEach((element) => {
//       element.id && (element.id = `${element.id}-${uniqueKey}`);
//       element.form && element.setAttribute('form', `${element.form.getAttribute('id')}-${uniqueKey}`);
//     });

//     oldNode.parentNode.insertBefore(newNode, oldNode);
//     oldNode.style.display = 'none';

//     postProcessCallbacks?.forEach((callback) => callback(newNode));

//     setTimeout(() => oldNode.remove(), 500);
//   }

//   // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
//   static setInnerHTML(element, html) {
//     element.innerHTML = html;
//     element.querySelectorAll('script').forEach((oldScriptTag) => {
//       const newScriptTag = document.createElement('script');
//       Array.from(oldScriptTag.attributes).forEach((attribute) => {
//         newScriptTag.setAttribute(attribute.name, attribute.value);
//       });
//       newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
//       oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
//     });
//   }
// }

// class QuantityInputDawn extends HTMLElement {
//   constructor() {
//     super();
//     this.input = this.querySelector('input');
//     this.changeEvent = new Event('change', { bubbles: true });
//     this.input.addEventListener('change', this.onInputChange.bind(this));
//     this.querySelectorAll('button').forEach((button) =>
//       button.addEventListener('click', this.onButtonClick.bind(this))
//     );
//   }

//   quantityUpdateUnsubscriber = undefined;

//   connectedCallback() {
//     this.validateQtyRules();
//     this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
//   }

//   disconnectedCallback() {
//     if (this.quantityUpdateUnsubscriber) {
//       this.quantityUpdateUnsubscriber();
//     }
//   }

//   onInputChange(event) {
//     this.validateQtyRules();
//   }

//   onButtonClick(event) {
//     event.preventDefault();
//     const previousValue = this.input.value;

//     if (event.target.name === 'plus') {
//       if (parseInt(this.input.dataset.min) > parseInt(this.input.step) && this.input.value == 0) {
//         this.input.value = this.input.dataset.min;
//       } else {
//         this.input.stepUp();
//       }
//     } else {
//       this.input.stepDown();
//     }

//     if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

//     if (this.input.dataset.min === previousValue && event.target.name === 'minus') {
//       this.input.value = parseInt(this.input.min);
//     }
//   }

//   validateQtyRules() {
//     const value = parseInt(this.input.value);
//     if (this.input.min) {
//       const buttonMinus = this.querySelector(".quantity__button[name='minus']");
//       buttonMinus.classList.toggle('disabled', parseInt(value) <= parseInt(this.input.min));
//     }
//     if (this.input.max) {
//       const max = parseInt(this.input.max);
//       const buttonPlus = this.querySelector(".quantity__button[name='plus']");
//       buttonPlus.classList.toggle('disabled', value >= max);
//     }
//   }
// }

// customElements.define('quantity-input-dawn', QuantityInputDawn);

// class ProductVariantSelects extends HTMLElement {
//   constructor() {
//     super();
//   }

//   connectedCallback() {
//     this.addEventListener('change', (event) => {
//       const target = this.getInputForEventTarget(event.target);
//       this.updateSelectionMetadata(event);

//       publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
//         data: {
//           event,
//           target,
//           selectedOptionValues: this.selectedOptionValues,
//         },
//       });
//     });
//   }

//   updateSelectionMetadata({ target }) {
//     const { value, tagName } = target;

//     if (tagName === 'SELECT' && target.selectedOptions.length) {

//       Array.from(target.options)
//         .find((option) => option.getAttribute('selected'))
//         .removeAttribute('selected');

//       // change previous target.selectedOptions with new value
//       const newSelectedOption = Array.from(target.options).find((option) => option.value === value);
//       if (newSelectedOption) {
//         newSelectedOption.setAttribute('selected', 'selected');
//       }

//       const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
//       const selectedDropdownSwatchValue = target
//         .closest('.product-form__input')
//         .querySelector('[data-selected-value] > .product-option__swatch');
//       if (!selectedDropdownSwatchValue) return;
//       if (swatchValue) {
//         selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
//         selectedDropdownSwatchValue.classList.remove('product-option__swatch--unavailable');
//       } else {
//         selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
//         selectedDropdownSwatchValue.classList.add('product-option__swatch--unavailable');
//       }

//       selectedDropdownSwatchValue.style.setProperty(
//         '--swatch-focal-point',
//         target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
//       );
//     } else if (tagName === 'INPUT' && target.type === 'radio') {
//       const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
//       if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
//     }
//   }

//   getInputForEventTarget(target) {
//     return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
//   }

//   get selectedOptionValues() {
//     return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
//       ({ dataset }) => dataset.optionValueId
//     );
//   }
// }
// customElements.define('product-variant-selects', ProductVariantSelects);

// if (!customElements.get('product-info')) {
//   customElements.define(
//     "product-info",
//     class ProductInfo extends HTMLElement {
//       quantityInput = undefined;
//       quantityForm = undefined;
//       onVariantChangeUnsubscriber = undefined;
//       cartUpdateUnsubscriber = undefined;
//       abortController = undefined;
//       pendingRequestUrl = null;
//       preProcessHtmlCallbacks = [];
//       postProcessHtmlCallbacks = [];

//       constructor() {
//         super();

//         this.quantityInput = this.querySelector(".quantity__input");
//         this.productMediaGallery = this.querySelector(`[id^="MediaGallery-${this.dataset.section}"]`);
//         this.productVariantSelects = this.querySelector('product-variant-selects');
//       }

//       connectedCallback() {
//         this.initializeProductSwapUtility();

//         this.onVariantChangeUnsubscriber = subscribe(
//           PUB_SUB_EVENTS.optionValueSelectionChange,
//           this.handleOptionValueChange.bind(this)
//         );

//         this.initQuantityHandlers();
//         this.dispatchEvent(
//           new CustomEvent("product-info:loaded", { bubbles: true })
//         );
//         this.initUpdateMedia();

         
//         if (this.productMediaGallery && this.productMediaGallery.dataset.hideOtherVariantsMedia === 'true') {
//           this.updateVariantMedia();
//         }
//       }

//       addPreProcessCallback(callback) {
//         this.preProcessHtmlCallbacks.push(callback);
//       }

//       initQuantityHandlers() {
//         if (!this.quantityInput) return;

//         this.quantityForm = this.querySelector(
//           ".product-form__quantity"
//         );
//         if (!this.quantityForm) return;

//         this.setQuantityBoundries();
//         if (!this.dataset.originalSection) {
//           this.cartUpdateUnsubscriber = subscribe(
//             PUB_SUB_EVENTS.cartUpdate,
//             this.fetchQuantityRules.bind(this)
//           );
//         }
//       }

//       initUpdateMedia() {
//         const variantIdFromUrl = parseInt(window.location.search.split('?').filter(item => item.includes('variant='))[0]?.split('=')[1]) || null;
//         if (!variantIdFromUrl) { return; }
//         const variant = this.getSelectedVariant(this);
//         if (!variant || !variantIdFromUrl) { return; }
//         if (variant?.id === variantIdFromUrl) {
//           this.updateMedia(variant?.featured_media?.id);
//         }
        
//       }

//       disconnectedCallback() {
//         this.onVariantChangeUnsubscriber();
//         this.cartUpdateUnsubscriber?.();
//       }

//       initializeProductSwapUtility() {
//         this.preProcessHtmlCallbacks.push(html =>
//           html
//             .querySelectorAll(".scroll-trigger")
//             .forEach(element =>
//               element.classList.add("scroll-trigger--cancel")
//             )
//         );
//         this.postProcessHtmlCallbacks.push(newNode => {
//           window?.Shopify?.PaymentButton?.init();
//           window?.ProductModel?.loadShopifyXR();
//         });
//       }

//       handleOptionValueChange({
//         data: { event, target, selectedOptionValues }
//       }) {
//         if (!this.contains(event.target)) return;

//         this.resetProductFormState();

//         const productUrl =
//           target.dataset.productUrl ||
//           this.pendingRequestUrl ||
//           this.dataset.url;
//         this.pendingRequestUrl = productUrl;
//         const shouldSwapProduct = this.dataset.url !== productUrl;
//         const shouldFetchFullPage =
//           this.dataset.updateUrl === "true" && shouldSwapProduct;

//         this.renderProductInfo({
//           requestUrl: this.buildRequestUrlWithParams(
//             productUrl,
//             selectedOptionValues,
//             shouldFetchFullPage
//           ),
//           targetId: target.id,
//           callback: shouldSwapProduct
//             ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
//             : this.handleUpdateProductInfo(productUrl)
//         });
//       }

//       resetProductFormState() {
//         const productForm = this.productForm;
//         productForm?.toggleSubmitButton(true);
//         productForm?.handleErrorMessage();
//       }

//       handleSwapProduct(productUrl, updateFullPage) {
//         return html => {
//           this.productModal?.remove();

//           const selector = updateFullPage
//             ? "product-info[id^='MainProduct']"
//             : "product-info";
//           const variant = this.getSelectedVariant(
//             html.querySelector(selector)
//           );
//           this.updateURL(productUrl, variant?.id);
//           if (updateFullPage) {
//             document.querySelector("head title").innerHTML =
//               html.querySelector("head title").innerHTML;

//             HTMLUpdateUtility.viewTransition(
//               document.querySelector("main"),
//               html.querySelector("main"),
//               this.preProcessHtmlCallbacks,
//               this.postProcessHtmlCallbacks
//             );
//           } else {
//             HTMLUpdateUtility.viewTransition(
//               this,
//               html.querySelector("product-info"),
//               this.preProcessHtmlCallbacks,
//               this.postProcessHtmlCallbacks
//             );
//           }
//         };
//       }

//       renderProductInfo({ requestUrl, targetId, callback }) {
//         this.abortController?.abort();
//         this.abortController = new AbortController();

//         fetch(requestUrl, { signal: this.abortController.signal })
//           .then(response => response.text())
//           .then(responseText => {
//             this.pendingRequestUrl = null;
//             const html = new DOMParser().parseFromString(
//               responseText,
//               "text/html"
//             );
//             callback(html);
//           })
//           .then(() => {
//             // set focus to last clicked option value
//             document.querySelector(`#${targetId}`)?.focus();
//           })
//           .catch(error => {
//             if (error.name === "AbortError") {
//               // console.log("Fetch aborted by user");
//             } else {
//               // console.error(error);
//             }
//           });
//       }

//       getSelectedVariant(productInfoNode) {
//         const selectedVariant = productInfoNode.querySelector(
//           "product-variant-selects [data-selected-variant]"
//         )?.innerHTML;
//         return !!selectedVariant ? JSON.parse(selectedVariant) : null;
//       }

//       buildRequestUrlWithParams(
//         url,
//         optionValues,
//         shouldFetchFullPage = false
//       ) {
//         const params = [];

//         !shouldFetchFullPage &&
//           params.push(`section_id=${this.sectionId}`);

//         if (optionValues.length) {
//           params.push(`option_values=${optionValues.join(",")}`);
//         }

//         return `${url}?${params.join("&")}`;
//       }

//       updateOptionValues(html) {
//         const productVariantSelects = html.querySelector("product-variant-selects");
//         if (productVariantSelects) {
//           HTMLUpdateUtility.viewTransition(
//             this.variantSelectors,
//             productVariantSelects,
//             this.preProcessHtmlCallbacks
//           );
//         }
//       }

//       handleUpdateProductInfo(productUrl) {
//         return html => {
//           const variant = this.getSelectedVariant(html);

//           // this.pickupAvailability?.update(variant);
//           this.updateOptionValues(html);
//           this.updateURL(productUrl, variant?.id);
//           this.updateVariantInputs(variant?.id);
//           this.updateVariantDiscountBadge(variant?.price, variant?.compare_at_price);
//           this.updateVariantDetails(variant?.id);
//           this.updateVariantMedia(html);
//           if (this.productMediaGallery && this.productMediaGallery.dataset.hideOtherVariantsMedia === 'true') {            
//           }

//           if (!variant) {
//             this.setUnavailable();
//             return;
//           }
//           this.updateMedia(variant?.featured_media?.id);

//           const updateSourceFromDestination = (
//             id,
//             shouldHide = source => false
//           ) => {
//             const source = html.getElementById(`${id}-${this.sectionId}`);
//             const destination = this.querySelector(`#${id}-${this.dataset.section}`);

//             if (source && destination) {

//               destination.innerHTML = source.innerHTML;

//               if (id === 'Inventory') {
//                 const inventoryThreshold = parseInt(source.dataset.inventoryThreshold);
//                 const inventoryQuantity = parseInt(source.dataset.inventoryQuantity);
//                 destination.classList.toggle("hidden", inventoryThreshold && inventoryQuantity > inventoryThreshold || inventoryQuantity < 1);
//               } else {
//                 destination.classList.toggle("hidden", shouldHide(source));
//               }
//             }
//           };

//           updateSourceFromDestination("ProductPurchaseInfo");
//           updateSourceFromDestination("ProductStickyCart");

//           updateSourceFromDestination("price");
//           updateSourceFromDestination("Sku", ({ classList }) => classList.contains("hidden"));

//           updateSourceFromDestination("Inventory", ({ innerText }) => innerText === "");

//           this.updateQuantityRules(this.sectionId, html);
//           this.querySelector(
//             `#Quantity-Rules-${this.dataset.section}`
//           )?.classList.remove("hidden");

//           this.productForm?.toggleSubmitButton(
//             html
//               .getElementById(`ProductSubmitButton-${this.sectionId}`)
//               ?.hasAttribute("disabled") ?? true,
//             window.variantStrings.soldOut
//           );
//           publish(PUB_SUB_EVENTS.variantChange, {
//             data: {
//               sectionId: this.sectionId,
//               html,
//               variant
//             }
//           });
//         };
//       }

//      updateVariantMedia(html) {
//             const doc = html;
//             const newSelectedHandle = this.querySelector(
//               'product-variant-selects [data-selected-variant-options-handle]'
//             )?.innerHTML.trim();

//             const newGrid = doc.querySelector('.main-product__media--grid');
//             const currentGrid = this.productMediaGallery.querySelector('.main-product__media--grid');

//             if (newGrid && currentGrid) {
//               currentGrid.replaceWith(newGrid);
//             }
//             const newSlider = doc.querySelector('.main-product__media--slider-wrapper');
//             const currentSlider = this.productMediaGallery.querySelector('.main-product__media--slider-wrapper');

//             if (newSlider && currentSlider) {
//               currentSlider.replaceWith(newSlider);
//             }
//             const newThumbs = doc.querySelector('.main-product__media--thumbs-wrapper');
//             const currentThumbs = this.productMediaGallery.querySelector('.main-product__media--thumbs-wrapper');

//             if (newThumbs && currentThumbs) {
//               currentThumbs.replaceWith(newThumbs);
//             }
//                   setTimeout(() => {
//                     requestAnimationFrame(() => {
//                       this.productMediaGallery.querySelectorAll('swiper-product-thumbs')
//                         .forEach(swiper => {
//                           if (swiper.instance) {
//                             swiper.instance.destroy(true, true);
//                           }
//                           swiper.style.display = 'none';
//                           swiper.offsetHeight;
//                           swiper.style.display = '';
//                           if (typeof swiper.init === 'function') {
//                             swiper.init();
//                           }
//                         });
//                       this.productMediaGallery.querySelectorAll('swiper-product-gallery')
//                         .forEach(swiper => {
//                           if (swiper.instance) {
//                             swiper.instance.destroy(true, true);
//                           }
//                           swiper.style.display = 'none';
//                           swiper.offsetHeight; 
//                           swiper.style.display = '';
//                           if (typeof swiper.init === 'function') {
//                             swiper.init();
//                           }
//                         });
//                     });
//                   }, 50);        
//           }
//  updateMediaSlides() {
//   const selectedInput = document.querySelector('.product-option__input:checked');
//   const selectedOp = selectedInput?.dataset.op?.toUpperCase();

//   const slides = document.querySelectorAll('.main-product__media--grid-item .swiper-slide[data-alt-op]');

//   slides.forEach(slide => {
//     const slideAltOp = slide.dataset.altOp?.toUpperCase();
    
//     if (slideAltOp === selectedOp) {
//       slide.classList.remove('hidden');
//     } else {
//       slide.classList.add('hidden');
//     }
//   });
//              const submitBtn = document.querySelector('.product-form__submit');
//   const paymentBtn = document.querySelector('.shopify-payment-button');
//   const appBtn = document.querySelector('.app-button');

//   if (submitBtn){

//   if (submitBtn.disabled) {
//     submitBtn.classList.add('hidden');
//     if (paymentBtn){
//     paymentBtn.classList.add('hidden');
//     }
//     if (appBtn){
//     appBtn.classList.remove('hidden');
//     }
//   } else {
//     submitBtn.classList.remove('hidden');
//     if (paymentBtn){
//     paymentBtn.classList.remove('hidden');
//     }
//     if (appBtn){
//     appBtn.classList.add('hidden');
//     }
//   }
//   }
//             const variantInput = document.querySelector('.product-variant-id');
//   const appButton = document.querySelector('.app-button');

//   if (variantInput && appButton) {
//     const variantId1 = variantInput.value;
//     appButton.setAttribute('data-variant', variantId1);
//   }
// }
//       updateVariantOptionMedia() {
//         this.productMediaGallery.querySelectorAll('[data-media-group]:not(.hidden)').forEach(element => {

//         });
//       }

//       updateVariantInputs(variantId) {
//         this.querySelectorAll(
//           `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
//         ).forEach(productForm => {
//           const input = productForm.querySelector('input[name="id"]');
//           input.value = variantId ?? "";
//           input.dispatchEvent(new Event("change", { bubbles: true }));
//         });     
//       }

//       updateURL(url, variantId) {
//         this.querySelector("share-button")?.updateUrl(
//           `${window.shopUrl}${url}${
//             variantId ? `?variant=${variantId}` : ""
//           }`
//         );
//         if (this.dataset.updateUrl === "false") return;
//         window.history.replaceState(
//           {},
//           "",
//           `${url}${variantId ? `?variant=${variantId}` : ""}`
//         );
//       }

//       updateSellingPlanURL(sellingPlanId, selectedVariantId) {
//         if (!selectedVariantId) return;
//         if (!sellingPlanId) {
//           window.history.replaceState({}, "", `${window.location.href.replace(/&selling_plan=\d+/, "")}`);
//         } else {
//           const params = new URLSearchParams(window.location.search);
//           params[params.has("variant") ? "set" : "append"](
//             "variant",
//             selectedVariantId
//           );
//           if (sellingPlanId) {
//             params[params.has("selling_plan") ? "set" : "append"](
//               "selling_plan",
//               sellingPlanId
//             );
//           } else {
//             params.delete("selling_plan");
//           }
//           window.history.replaceState({}, "", `${this.dataset.url}?${params.toString()}`);
//         }
//       }

//       updateVariantDetails(variantId) {
//         const productVariantDetails = this.querySelectorAll('.product__metafield_for_variant-block');
//         if (productVariantDetails) {
//           productVariantDetails.forEach((productVariantDetail) => {
//             const block_id = productVariantDetail.getAttribute('data-block-id');
//             const metafieldDataElement = this.querySelector(`#product__metafield_for_variant-block--${block_id}`);
//             if (!metafieldDataElement) {
//               return;
//             }
//             try {
//               let productVariantDetailsData = JSON.parse(metafieldDataElement?.textContent);
//               productVariantDetail.innerHTML = productVariantDetailsData?.[variantId]?.replaceAll('\n', '<br />') || '';
//             } catch (error) {
//               console.error('Error parsing JSON', error);
//             }
//           });
//         }
//       }

//       updateVariantDiscountBadge(price, compare_at_price) {
//         const discountBadge = this.querySelector(".product-card__badge--discount");
//         if (!discountBadge) return;


//         if (compare_at_price > price) {
//           discountBadge.classList.remove("hidden");
//           const percentageElement = discountBadge.querySelector(".percentage");
//           // calculate discount percentage
//           const discountPercentage = Math.round(
//             ((compare_at_price - price) / compare_at_price) * 100
//           );
//           // update discount percentage
//           percentageElement.textContent = discountPercentage;
//         } else {
//           discountBadge.classList.add("hidden");
//         }
//       }

//       setUnavailable() {
//         this.productForm?.toggleSubmitButton(
//           true,
//           window.variantStrings.unavailable
//         );

//         const selectors = [
//           "price",
//           "Inventory",
//           "Sku",
//           "Quantity-Rules"
//         ]
//           .map(id => `#${id}-${this.dataset.section}`)
//           .join(", ");
//         document
//           .querySelectorAll(selectors)
//           .forEach(({ classList }) => classList.add("hidden"));
//       }

//       updateMedia(variantFeaturedMediaId) {
//         if (!variantFeaturedMediaId) return;

//         if (
//           this.querySelector(".main-product__media")?.hasAttribute(
//             "data-desktop-grid"
//           ) && window.innerWidth >= 750
//         ) {
//           this.scrollToImage(variantFeaturedMediaId);
//         }

//         const productMedia = this.querySelector(
//           "swiper-product-gallery"
//         );
//         productMedia?.setActiveMedia(variantFeaturedMediaId);
//       }

//       scrollToImage(variantFeaturedMediaId) {
//         this.querySelectorAll("[data-media-id]").forEach(img => {
//           if (
//             img.getAttribute("data-media-id") ==
//             variantFeaturedMediaId
//           ) {
//             img.scrollIntoView({
//               block: "end",
//               behavior: "smooth"
//             });
//           }
//         });
//       }

//       setQuantityBoundries() {
//         const data = {
//           cartQuantity: this.quantityInput.dataset.cartQuantity
//             ? parseInt(this.quantityInput.dataset.cartQuantity)
//             : 0,
//           min: this.quantityInput.dataset.min
//             ? parseInt(this.quantityInput.dataset.min)
//             : 1,
//           max: this.quantityInput.dataset.max
//             ? parseInt(this.quantityInput.dataset.max)
//             : null,
//           step: this.quantityInput.step
//             ? parseInt(this.quantityInput.step)
//             : 1
//         };

//         let min = data.min;
//         const max =
//           data.max === null ? data.max : data.max - data.cartQuantity;
//         if (max !== null) min = Math.min(min, max);
//         if (data.cartQuantity >= data.min)
//           min = Math.min(min, data.step);

//         this.quantityInput.min = min;

//         if (max) {
//           this.quantityInput.max = max;
//         } else {
//           this.quantityInput.removeAttribute("max");
//         }
//         this.quantityInput.value = min;

//         publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
//       }

//       fetchQuantityRules() {
//         const currentVariantId =
//           this.productForm?.variantIdInput?.value;
//         if (!currentVariantId) return;

//         this.querySelector(
//           ".quantity__rules-cart .loading__spinner"
//         ).classList.remove("hidden");
//         fetch(
//           `${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`
//         )
//           .then(response => response.text())
//           .then(responseText => {
//             const html = new DOMParser().parseFromString(
//               responseText,
//               "text/html"
//             );
//             this.updateQuantityRules(this.dataset.section, html);
//           })
//           .catch(e => console.error(e))
//           .finally(() =>
//             this.querySelector(
//               ".quantity__rules-cart .loading__spinner"
//             ).classList.add("hidden")
//           );
//       }

//       updateQuantityRules(sectionId, html) {
//         if (!this.quantityInput) return;
//         this.setQuantityBoundries();

//         const quantityFormUpdated = html.getElementById(
//           `Quantity-Form-${sectionId}`
//         );
//         const selectors = [
//           ".quantity__input",
//           ".quantity__rules",
//           ".quantity__label"
//         ];
//         for (let selector of selectors) {
//           const current = this.quantityForm.querySelector(selector);
//           const updated = quantityFormUpdated.querySelector(selector);
//           if (!current || !updated) continue;
//           if (selector === ".quantity__input") {
//             const attributes = [
//               "data-cart-quantity",
//               "data-min",
//               "data-max",
//               "step"
//             ];
//             for (let attribute of attributes) {
//               const valueUpdated = updated.getAttribute(attribute);
//               if (valueUpdated !== null) {
//                 current.setAttribute(attribute, valueUpdated);
//               } else {
//                 current.removeAttribute(attribute);
//               }
//             }
//           } else {
//             current.innerHTML = updated.innerHTML;
//           }
//         }
//       }

//       get productForm() {
//         return this.querySelector(`product-form`);
//       }

//       get productModal() {
//         return document.querySelector(
//           `#ProductModal-${this.dataset.section}`
//         );
//       }

//       get pickupAvailability() {
//         return this.querySelector(`pickup-availability`);
//       }

//       get variantSelectors() {
//         return this.querySelector("product-variant-selects");
//       }

//       get relatedProducts() {
//         const relatedProductsSectionId = SectionId.getIdForSection(
//           SectionId.parseId(this.sectionId),
//           "related-products"
//         );
//         return document.querySelector(
//           `product-recommendations[data-section-id^="${relatedProductsSectionId}"]`
//         );
//       }

//       get quickOrderList() {
//         const quickOrderListSectionId = SectionId.getIdForSection(
//           SectionId.parseId(this.sectionId),
//           "quick_order_list"
//         );
//         return document.querySelector(
//           `quick-order-list[data-id^="${quickOrderListSectionId}"]`
//         );
//       }

//       get sectionId() {
//         return this.dataset.originalSection || this.dataset.section;
//       }
//     }
//   );
// }

// if (!customElements.get('product-form')) {
//   customElements.define(
//     "product-form",
//     class ProductForm extends HTMLElement {
//       constructor() {
//         super();

//         this.form = this.querySelector("form");
//         this.variantIdInput.disabled = false;
//         this.form.addEventListener(
//           "submit",
//           this.onSubmitHandler.bind(this)
//         );
//         this.cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
//         this.submitButton = this.querySelector('[type="submit"]');
//         this.submitButtonText =
//           this.submitButton.querySelector("span");

//         if (document.querySelector("cart-drawer"))
//           this.submitButton.setAttribute("aria-haspopup", "dialog");

//         this.hideErrors = this.dataset.hideErrors === "true";
//       }

//       onSubmitHandler(evt) {
//         evt.preventDefault();
//         if (
//           this.submitButton.getAttribute("aria-disabled") === "true"
//         )
//           return;

//         this.handleErrorMessage();

//         this.submitButton.setAttribute("aria-disabled", true);
//         this.submitButton.classList.add("loading");
//         this.querySelector(".loading__spinner").classList.remove(
//           "hidden"
//         );

//         const config = fetchConfig("javascript");
//         config.headers["X-Requested-With"] = "XMLHttpRequest";
//         delete config.headers["Content-Type"];

//         const formData = new FormData(this.form);
//         if (this.cart) {
//           formData.append(
//             "sections",
//             this.cart
//               .getSectionsToRender()
//               .map(section => section.section)
//           );
//           formData.append("sections_url", window.location.pathname);
//           this.cart.setActiveElement(document.activeElement);
//         }
//         config.body = formData;

//         fetch(`${routes.cart_add_url}`, config)
//           .then(response => response.json())
//           .then(response => {
//             if (response.status) {
//               publish(PUB_SUB_EVENTS.cartError, {
//                 source: "product-form",
//                 productVariantId: formData.get("id"),
//                 errors: response.errors || response.description,
//                 message: response.message
//               });
//               this.handleErrorMessage(response.description);

//               const soldOutMessage = this.submitButton.querySelector(
//                 ".sold-out-message"
//               );
//               if (!soldOutMessage) return;
//               this.submitButton.setAttribute("aria-disabled", true);
//               this.submitButtonText.classList.add("hidden");
//               soldOutMessage.classList.remove("hidden");
//               this.error = true;
//               return;
//             } else if (!this.cart) {
//               window.location = window.routes.cart_url;
//               return;
//             }

//             if (!this.error)
//               publish(PUB_SUB_EVENTS.cartUpdate, {
//                 source: "product-form",
//                 productVariantId: formData.get("id"),
//                 cartData: response
//               });
//             this.error = false;
//             this.cart.renderContents(response);
//           })
//           .catch(e => {
//             console.error(e);
//           })
//           .finally(() => {
//             this.submitButton.classList.remove("loading");
//             if (this.cart && this.cart.classList.contains("is-empty"))
//               this.cart.classList.remove("is-empty");
//             if (!this.error)
//               this.submitButton.removeAttribute("aria-disabled");
//             this.querySelector(".loading__spinner").classList.add(
//               "hidden"
//             );
//           });
//       }

//       handleErrorMessage(errorMessage = false) {
//         if (this.hideErrors) return;

//         this.errorMessageWrapper =
//           this.errorMessageWrapper ||
//           this.querySelector(".product-form__error-message-wrapper");
//         if (!this.errorMessageWrapper) return;
//         this.errorMessage =
//           this.errorMessage ||
//           this.errorMessageWrapper.querySelector(
//             ".product-form__error-message"
//           );

//         this.errorMessageWrapper.toggleAttribute(
//           "hidden",
//           !errorMessage
//         );

//         if (errorMessage) {
//           this.errorMessage.textContent = errorMessage;
//         }
//       }

//       toggleSubmitButton(disable = true, text) {
//         if (disable) {
//           this.submitButton.setAttribute("disabled", "disabled");
//           if (text) this.submitButtonText.textContent = text;
//         } else {
//           this.submitButton.removeAttribute("disabled");
//           this.submitButtonText.textContent = this.hasAttribute(
//             "data-has-selling-plan"
//           )
//             ? window.variantStrings.addSubscriptionToCart
//             : this.submitButtonText.textContent = this.hasAttribute(
//                 "data-has-pre-order"
//               )
//             ?  window.variantStrings.preOrder
//             : window.variantStrings.addToCart;
//         }
//       }

//       get variantIdInput() {
//         return this.form.querySelector("[name=id]");
//       }
//     }
//   );
// }
// function isVisible(el) {
//   return el && el.offsetWidth > 0 && el.offsetHeight > 0;
// }

// /* =========================
// ✅ AUTO SELECT SIZE (FIXED)
// ========================= */

// function autoSelectFirstAvailableSize() {
//   const sizeInputs = document.querySelectorAll('.product-option__input[name*="Size"]');
//   if (!sizeInputs.length) return;
//   let validSelected = null;

//   sizeInputs.forEach(input => {
//     if (input.checked && isVisible(input)) {
//       validSelected = input;
//     }
//   });

//   // console.log('validSelected',validSelected)
//   // ❗ If selected is gone → pick new one
//   if (!validSelected) {
//     const firstVisible = Array.from(sizeInputs).find(input => isVisible(input));
//     // console.log('firstVisible',firstVisible)
//     if (firstVisible) {
//       // Use click → ensures Shopify updates variant
//       firstVisible.click();
//     }
//   }
// }
// subscribe(PUB_SUB_EVENTS.variantChange,event => {
//   console.log('on varint change',event)
//   autoSelectFirstAvailableSize();
// });

